import camelCase from "lodash/camelCase";
import lodashTemplate from "lodash.template";
/**
 * Return random string
 * The length of the random string may differ but in most cases it returns 22 chars
 */
export function strRand() {
    return (Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15));
}
/** Compile a string template, for more info see lodash library */
export function strTemplate(template, options) {
    const compiled = lodashTemplate(template);
    return compiled(options);
}
/** Check if string contains HTML */
export function strContainsHTML(str) {
    return /<[a-z][\s\S]*>/i.test(str);
}
export function strCamelCase(str) {
    return camelCase(str);
}
//# sourceMappingURL=Str.js.map